import FeatherIcon from 'feather-icons-react';
import { InputFromUser } from '../Input/input';

/**
 * VirechanExerciseSection Component
 * Handles Virechan and Exercise selections in a responsive layout
 */
const VirechanExerciseSection = ({
    values,
    handleChange,
    IsFilledForm,
    ConsultationMasterData,
}) => {
    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        {/* Section Header */}
                        <h4
                            style={{
                                color: '#111827',
                                fontWeight: '700',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '20px'
                            }}
                        >
                            <FeatherIcon icon="activity" size="20" style={{ color: '#4f46e5' }} />
                            Virechan & Exercise
                        </h4>

                        <div className="row">
                            {/* Virechan */}
                            <div className="col-12 col-md-6 mb-3 mb-md-0">
                                <InputFromUser
                                    disabled={IsFilledForm}
                                    placeholder="Enter Your Virechan"
                                    type="singleSelect"
                                    options={
                                        (ConsultationMasterData?.virechans &&
                                            ConsultationMasterData?.virechans?.map(v => v.title)) ||
                                        []
                                    }
                                    name="virechan"
                                    onChange={v => {
                                        handleChange({
                                            target: {
                                                name: 'virechan',
                                                value: v,
                                            },
                                        });
                                    }}
                                    FormGroupClassName="w-100"
                                    LabelClassName="col-form-label"
                                    onBlur={undefined}
                                    label="Virechan"
                                    value={values.virechan}
                                />
                            </div>

                            {/* Exercise */}
                            <div className="col-12 col-md-6">
                                <InputFromUser
                                    disabled={IsFilledForm}
                                    placeholder="Enter Your Exercise"
                                    type="multiple"
                                    options={
                                        (ConsultationMasterData?.exercises &&
                                            ConsultationMasterData?.exercises?.map(v => v.title)) ||
                                        []
                                    }
                                    name="exercise"
                                    onChange={v => {
                                        handleChange({
                                            target: {
                                                name: 'exercise',
                                                value: v,
                                            },
                                        });
                                    }}
                                    value={values.exercise}
                                    FormGroupClassName="w-100"
                                    LabelClassName="col-form-label"
                                    onBlur={undefined}
                                    label="Exercise"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VirechanExerciseSection;
